import React, { Component } from "react";
import {inject } from 'mobx-react';
import Utils from '../../common/Utils';
import StorageHelper from "../StorageHelper";
import { BROWSER_KEY } from "../Foundation";

@inject('LayoutTemplateStore', 'AccountStore')
export default function tncChecker() {
    return (Child) => {
        return class extends Component {

            componentDidMount() {
                this.checkIsShowTCPage();
            }

            componentDidUpdate() {
                this.checkIsShowTCPage();
            }

            checkIsShowTCPage() {
                let activeFirstLogin = false;
                const isShowAcceptTC = StorageHelper.getBrowsersStorage(BROWSER_KEY.IS_SHOW_ACCEPT_TC);
                if (isShowAcceptTC) {
                    activeFirstLogin = JSON.parse(isShowAcceptTC);
                }
                if (activeFirstLogin && 
                    this.props.AccountStore.isAuth &&
                    this.props.LayoutTemplateStore.currentPageContainer !== 'termsConditionsPageContainer' &&
                    window.location.href.indexOf('ngc') === -1 &&
                    window.location.href.indexOf('change-password') === -1) {
                    let viewPath = '';
                    let viewOnURL = Utils.getViewPathByURLPath();
                    if (viewOnURL === 'asian') {
                        viewPath = '/' + Utils.getCurrentLang() + '/' + viewOnURL + '/tc-page';
                    } else {
                        viewPath = '/' + Utils.getUserLanguage() + '/tc-page';
                    }
                    this.props.history.push(viewPath);
                }
            }

            render() {
                return (
                    <Child {...this.props} />
                );
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/decorator/tncChecker.js